<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" :initialFocus="activeElement" @close="closeModal">
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="min-h-screen px-4 text-center flex">
          <DialogOverlay class="fixed inset-0 bg-black opacity-30" />

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              class="
                inline-block
                w-full
                max-w-lg
                p-6
                m-auto
                overflow-hidden
                text-left
                align-middle
                transition-all
                transform
                bg-white
                shadow-xl
                rounded
              "
            >
              <div class="flex flex-row pb-4">
                <div class="flex-1">
                  <h3 class="text-xl leading-6 text-brand-black">Warning</h3>
                </div>
                <div class="flex-4 cursor-pointer" @click.prevent="closeModal">
                  <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                </div>
              </div>

              <div class="py-4">
                <p class="text-brand-black">
                  APPLICANTS Please be aware of scams.
                </p>
              </div>

              <div class="py-4">
                <p class="text-brand-black text-sm">
                  A warning is being displayed for this application because
                  either:
                </p>
                <br />
                <ol class="list-decimal list-inside px-2">
                  <li class="text-brand-black text-sm">
                    The landlord or property manager has not yet verified the
                    account and Rent Application is unable to determine the
                    nature of the business, or
                  </li>
                  <li class="text-brand-black text-sm">
                    It has been flagged by other applicants as a potential scam.
                  </li>
                </ol>
              </div>

              <div class="py-4">
                <p class="text-brand-black text-sm">
                  This does NOT mean that the application is a scam. It simply
                  means that Rent Application has not been able to verify the
                  property manager or landlord yet.
                </p>
                <p class="text-brand-black text-sm mt-2">
                  As a safety precaution against identity theft, whenever
                  possible, please visit the rental unit or speak with the
                  landlord or property manager before submitting personal
                  information.
                </p>
              </div>

              <div class="py-2 w-full">
                <button
                  class="
                    block
                    mx-auto
                    w-full
                    md:w-2/3
                    bg-brand-red
                    border-2 border-brand-red
                    text-white text-sm
                    font-bold
                    py-2
                    px-2
                    rounded
                    focus:outline-none
                  "
                  ref="actionButton"
                  @click.prevent="closeModal"
                >
                  I Understand And Accept The Risks
                </button>
              </div>

              <div class="py-4">
                <router-link
                  :to="{ name: 'home_applicant_warning_message' }"
                  class="text-sm text-brand-blue"
                >
                  Property Managers: Why is this message displayed? How do I
                  remove it?
                </router-link>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay
} from "@headlessui/vue"

import { XIcon } from "@heroicons/vue/outline"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  computed: {
    activeElement() {
      return document.activeElement
    }
  },
  methods: {
    closeModal() {
      this.$emit("close")
    }
  }
}
</script>
